import styled from "styled-components";


export const ContainerEditPhoto = styled.label`
margin: 20px;
width: 100%;
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
height: 62px;
gap: 10px;
cursor: pointer;

border: none;

border-radius: 10px;

background: #E0F0F5;
/* Blur_04 */

backdrop-filter: blur(20px);

font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 20px;
/* identical to box height */


color: #556ED1;

`;